module.exports = __webpack_public_path__ + "bca018cab1f0a1d379d23c25557b0d63.svg";